import { IconType } from 'react-icons';
import { AiOutlineClose } from 'react-icons/ai';
import { LuInfo } from 'react-icons/lu';
import { twMerge } from 'tailwind-merge';

type AlertProps = {
  icon: IconType;
  title: string;
  contents: string[];
  className?: string;
};

export const Alert = ({
  icon: Icon,
  title,
  contents,
  className,
}: AlertProps) => {
  return (
    <div className={twMerge('flex gap-2 rounded-lg p-4', className)}>
      <Icon className="size-5 shrink-0" />
      <div className="flex flex-col gap-2">
        <p className="text-sm font-bold">{title}</p>
        <ul className={twMerge(contents.length > 1 && 'ml-5 list-disc')}>
          {contents.map((content) => (
            <li key={content} className="text-sm">
              {content}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export const InfoAlert = (props: Omit<AlertProps, 'icon'>) => {
  return (
    <Alert icon={LuInfo} className="bg-[#F0F9FF] text-[#0EA5E9]" {...props} />
  );
};

export const ErrorAlert = (props: Omit<AlertProps, 'icon'>) => {
  return (
    <Alert
      icon={AiOutlineClose}
      className="bg-[#FEF2F2] text-error"
      {...props}
    />
  );
};

export const WarningAlert = (props: Omit<AlertProps, 'icon'>) => {
  return (
    <Alert icon={LuInfo} className="bg-[#FFF7ED] text-[#F97316]" {...props} />
  );
};
